'use strict';

var BaseCSSConstants = require('_core_ext/cssconstants');
var layout = require('_core_ext/layout');
var JSConstants = require('_core_ext/pages/tradecard/constants');
var CSSConstants = require('_core_ext/pages/tradecard/cssconstant');

var createAccount = require('./events/createAccount');
var barberTriggers = require('./events/barberTriggers');
var handleAddress = require('./events/address');
var handleStoreSelection = require('./events/storeSelection');
var fileUploaders = require('./events/fileUploaders');
var validation = require('./events/validation');
var popup = require('./events/popup');
var roleSelector = require('./events/roleSelector');
var prefillAddress = require('./events/prefillAddress');

require('regenerator-runtime/runtime');

var cache = {};

function initializeCache() {
    cache.$window = $(window);
    cache.$stepperProgressBar = $(JSConstants.STEPPER_PROGRESS);
    cache.$stepperTab = $(JSConstants.STEPPER_TAB);
    cache.stepsAmount = cache.$stepperTab.length;
    cache.$stepperTabs = $(JSConstants.STEPPER_TABS);
    cache.$stepperNav = $(JSConstants.STEPPER_NAV);
    cache.$stepperTabsList = $(JSConstants.STEPPER_LIST);
    cache.stepperTabsWidth = cache.$stepperTabs.outerWidth();
    cache.totalStepsCount = $(CSSConstants.STEPPER + '[data-step]').length;
    cache.activeStep = 1;

    cache.isUpgrade = $('form' + JSConstants.UPGRADE_FORM).length > 0;
    cache.isExtend = $('form' + JSConstants.EXTEND_FORM).length > 0;
    cache.isOffline = $('form' + JSConstants.OFFLINE_FORM).length > 0;
    cache.isNewTradeCard = !(cache.isUpgrade || cache.isExtend || cache.isOffline);
}

function moveProgressBarTo(step) {
    cache.$stepperProgressBar.width(step / cache.stepsAmount * 100 + '%');
}

function centerFirstAndLastTabs() {
    var paddLeft = 0;
    var paddRight = 0;

    if (layout.isMobile()) {
        paddLeft = (cache.stepperTabsWidth - cache.$stepperTab.first().innerWidth()) / 2;
        paddRight = (cache.stepperTabsWidth - cache.$stepperTab.last().innerWidth()) / 2;
    }

    cache.$stepperTabsList
        .css({
            'padding-left': paddLeft,
            'padding-right': paddRight
        });
}

function animateLastStep() {
    if (cache.activeStep === cache.$stepperTab.length) {
        // user is moving from last step
        cache.$stepperTabs
            .removeClass(CSSConstants._LAST_STEP_ACTIVE)
            .addClass(CSSConstants._LAST_STEP_WAS_ACTIVE);
    } else {
        // user is moving to last step
        cache.$stepperTabs
            .addClass(CSSConstants._LAST_STEP_ACTIVE)
            .removeClass(CSSConstants._LAST_STEP_WAS_ACTIVE);
    }
}

function addGetParameterToLocation(paramName, paramValue) {
    const url = new URL(window.location.href);

    url.searchParams.delete(paramName);
    url.searchParams.append(paramName, paramValue);

    window.history.pushState({}, '', url);
}

function removeGetParameterFromLocation(paramName) {
    const url = new URL(window.location.href);

    url.searchParams.delete(paramName);
    window.history.pushState({}, '', url);
}

function switchStep(step) {
    switchTab(step);
    switchStepContent(step);
    cache.activeStep = step;

    var $currentTab = cache.$stepperTab.filter(function() {
        return $(this).data('step') === step;
    });

    disableNextStepperTabs($currentTab);
    $(document).scrollTop(0);
    $('.js-registration-options').removeClass(CSSConstants.HIDDEN);
    $(JSConstants.CLASS_REG_OPTION_SECTION).addClass(CSSConstants.HIDDEN);

    if (!$(CSSConstants.STEPPER_ROLE + '.js-student').is(':visible')) {
        $(JSConstants.STEPPER_TAB + ' .js-student').addClass(CSSConstants.HIDDEN);
        $(JSConstants.STEPPER_TAB + ' .js-professional').removeClass(CSSConstants.HIDDEN);
        $(CSSConstants.STEPPER_ROLE_TITLE + '.js-professional, ' + CSSConstants.STEPPER_ROLE_DESCRIPTION + '.js-professional').removeClass(CSSConstants.HIDDEN).show();
    } else {
        $(JSConstants.STEPPER_TAB + ' .js-student').removeClass(CSSConstants.HIDDEN);
        $(JSConstants.STEPPER_TAB + ' .js-professional').addClass(CSSConstants.HIDDEN);
        $(CSSConstants.STEPPER_ROLE_DESCRIPTION + '.js-professional').addClass(CSSConstants.HIDDEN).hide();
    }

    $(CSSConstants.STEPPER_ROLE_TITLE + '.js-professional-upload').addClass(CSSConstants.HIDDEN).hide();
    $(CSSConstants.STEPPER_ROLE + '.js-professional .js-step3-next').addClass(CSSConstants.HIDDEN).hide();

    setTitle(step);

    if (JSConstants.CONSTANTS.POSSIBLE_STEPS_IN_URL.indexOf(step) > -1) {
        addGetParameterToLocation('step', step);
    } else {
        removeGetParameterFromLocation('step');
    }

    if (JSConstants.CONSTANTS.STAGE_EVENT_STEPS[step]) {
        $(document).trigger('tradecard.stageEvent',
        [
            JSConstants.CONSTANTS.STAGE_VIEW,
            JSConstants.CONSTANTS.STAGE_EVENT_STEPS[step]
        ]);
    }

    window.dataLayer = window.dataLayer || [];

    let pageviewEvent = window.dataLayer.find(key => key.event === 'pageview');

    dataLayer.push({ // eslint-disable-line
        event: 'pageview',
        page_type: 'registation_step' + step,
        user: pageviewEvent ? pageviewEvent.user : {},
        site: pageviewEvent ? pageviewEvent.site : {}
    });
}

function switchTab(destinationStep) {
    var $activeTab = cache.$stepperTab
        .removeClass(CSSConstants.ACTIVE)
        .filter('[data-step="' + destinationStep + '"]');

    if ($activeTab.length) { // Else - Thank you page, probably (wich has not tab)
        $activeTab.removeAttr('disabled')
            .addClass(CSSConstants.ACTIVE);

        if (cache.activeStep === cache.$stepperTab.length || destinationStep === cache.$stepperTab.length) {
            animateLastStep();
        } else {
            cache.$stepperTabs
                .removeClass(CSSConstants._LAST_STEP_WAS_ACTIVE);
        }

        if (layout.isMobile()) {
            scrollTabsTo($activeTab);
        }

        moveProgressBarTo(destinationStep);
    }
}

function setTitle(step) {
    let $registration = $(JSConstants.REGISTRATION_FORM);
    let metaTile = $registration.data('title-step-' + step);

    if (metaTile) {
        $('head title').text(metaTile);
    }
}

function switchStepContent(destinationStep) {
    $(CSSConstants.STEPPER)
        .removeClass(CSSConstants._STEPPER_STEP_ACIVE)
        .filter('[data-step="' + destinationStep + '"]')
        .addClass(CSSConstants._STEPPER_STEP_ACIVE);
}

function disableNextStepperTabs ($tabsSet) {
    if ($tabsSet && $tabsSet.length) {
        $tabsSet.parent().nextAll().find(JSConstants.STEPPER_TAB).prop('disabled', true);
    }
}

function scrollTabsTo($activeTab) {
    var newScrollToLeftSide = cache.$stepperNav.scrollLeft() + $activeTab.offset().left;
    var newScroll;

    if (cache.stepperTabsWidth > $activeTab.innerWidth()) {
        //align tab to center
        newScroll = newScrollToLeftSide - cache.stepperTabsWidth / 2 + $activeTab.innerWidth() / 2;
    } else {
        //align tab to left
        newScroll = newScrollToLeftSide;
    }

    cache.$stepperNav.animate({
        scrollLeft: (newScroll)
    }, BaseCSSConstants.TRANSITION_DURATION, 'linear');

}

function initializeEvents() {
    var initStep = 1;

    centerFirstAndLastTabs();
    moveProgressBarTo(initStep);

    if (cache.isExtend) {
        selectRole(JSConstants.CONSTANTS.STUDENT);
    }

    cache.$window.on('resize', function() {
        cache.stepperTabsWidth = cache.$stepperTabs.outerWidth();
        centerFirstAndLastTabs();
    });

    $(document)
        .on('click', '[data-destination-step]', function (e) {
            e.preventDefault();

            var isStoreChecked = $('.js-store-reference-container').is(':visible') ? Number($('.js-store-reference-container').attr('data-store-checked')) : true;
            if (!isStoreChecked) {return;}

            prefillAddress();
            var $el = $(e.currentTarget);
            var destinationStep = +$el.data('destination-step');
            var currentStep = +$el.data('current-step');

            if ($el.data('call-complete-event') && JSConstants.CONSTANTS.STAGE_EVENT_STEPS[currentStep]) {
                $(document).trigger('tradecard.stageEvent',
                [
                    JSConstants.CONSTANTS.COMPLETE_STAGE,
                    JSConstants.CONSTANTS.STAGE_EVENT_STEPS[currentStep]
                ]);
            }

            switchStep(destinationStep);
            $el.trigger('change');
            $(CSSConstants.STEPPER_INFO_DISABLED).find(JSConstants.BARBER_ACTIVATOR_BUTTON).trigger('click');
        })
        .on('click', '[data-destination-role]', function (e) {
            e.preventDefault();

            var $el = $(e.currentTarget);
            var destinationRole = $el.data('destination-role');
            var $activeTabs = $(JSConstants.STEPPER_TAB + '.' + CSSConstants.ACTIVE);

            $(document).trigger('tradecard.singupStart', [JSConstants.CONSTANTS.PROFESSION_TYPE[destinationRole.toUpperCase()]]);
            disableNextStepperTabs($activeTabs);
            $(JSConstants.BARBER_GO_BACK_BUTTON).trigger('click');

            selectRole(destinationRole);
        })
        .on('change', 'input' + JSConstants.PROF_TYPE, function() {
            var value = $(this).val();
            var $otherProfession = $(JSConstants.OTHER_PROFESSION);

            $otherProfession.toggleClass(CSSConstants.HIDDEN, value !== JSConstants.CONSTANTS.ROLES.OTHER);
        })
        .on('change', 'select' + JSConstants.STADY_TYPE, function () {
            var value = $(this).val();
            var $otherProfession = $(JSConstants.OTHER_STADY);

            $otherProfession.toggleClass(CSSConstants.HIDDEN, value !== JSConstants.CONSTANTS.ROLES.OTHER);
        }).on('click', JSConstants.STEPPER_SHOW_OPTION, function (e) {
            e.preventDefault();

            var $el = $(e.currentTarget);
            var destinationSection = $el.data('opensection');

            if (destinationSection) {
                $(CSSConstants.STEPPER_ROLE_TITLE + '.js-professional, ' + CSSConstants.STEPPER_ROLE_DESCRIPTION + '.js-professional').addClass(CSSConstants.HIDDEN).hide();
                $(CSSConstants.STEPPER_ROLE_TITLE + '.js-professional-upload').removeClass(CSSConstants.HIDDEN).show();
                $(CSSConstants.STEPPER_ROLE + '.js-professional .js-step3-next').removeClass(CSSConstants.HIDDEN).show();
                $('.js-registration-options').addClass(CSSConstants.HIDDEN);
                $(JSConstants.CLASS_REG_OPTION_SECTION).addClass(CSSConstants.HIDDEN);

                var $targetSection = $('#' + destinationSection);

                if ($targetSection.length) {
                    $targetSection.removeClass(CSSConstants.HIDDEN);
                }
            }
        });
}


function selectRole(destinationRole) {
    $(JSConstants.CUSTOMER_TYPE).val(destinationRole);
    $(JSConstants.CUSTOMER_TYPE_VALUE).val(destinationRole === JSConstants.CONSTANTS.STUDENT ? 'S' : 'P');

    var $registration = $(JSConstants.REGISTRATION_FORM);
    var $steperRoles = $registration.find(CSSConstants.STEPPER_ROLE);
    $steperRoles.addClass(CSSConstants.HIDDEN);
    $steperRoles.hide();

    var $selectedRole = $registration.find('.js-' + destinationRole);
    $selectedRole.removeClass(CSSConstants.HIDDEN);
    $selectedRole.show();
}

module.exports = {
    init: function () {
        // always go to the start page
        removeGetParameterFromLocation('step');

        initializeCache();
        initializeEvents();

        fileUploaders.init();
        barberTriggers.init();
        handleAddress.init();
        handleStoreSelection.init();
        roleSelector.init();
        validation.init();

        if (cache.isNewTradeCard) {
            popup.init();
        }

        createAccount(function (data, $confirmationBlock) {
            if ($confirmationBlock && $confirmationBlock.length) {
                $(JSConstants.CONFIRMATION_BLOCK).replaceWith($confirmationBlock);
            }

            $(document).trigger('tradecard.singupComplete');

            switchStep(cache.totalStepsCount);
            $(JSConstants.STEPPER_TAB).prop('disabled', true);
        });
    }
};
